import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar'; // Ensure this path is correct based on your project structure
import Footer from '../components/Footer'; // Corrected import path
import './Contact.css'; // Ensure the path to your CSS file is correct

const Contact = () => {
  // State to manage form input
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Update the page title
  useEffect(() => {
    document.title = "Contact - TureMedicine";
  }, []);

  // State to handle form submission status
  const [submitStatus, setSubmitStatus] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for actual form submission logic (e.g., send data to a backend)
    if (formData.name && formData.email && formData.message) {
      setSubmitStatus('Your message has been sent successfully!');
      setFormData({ name: '', email: '', message: '' }); // Clear the form
    } else {
      setSubmitStatus('Please fill in all fields.');
    }
  };

  return (
    <>
      <Navbar /> {/* Navbar added here */}
      <div className="contact-page">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>We&apos;d love to hear from you. Reach out to us for any inquiries or support.</p>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn">Send Message</button>
        </form>
        {submitStatus && <p className="submit-status">{submitStatus}</p>}
      </div>
      <Footer /> {/* Footer will be shown on every page */}      
    </>
  );
};

export default Contact;
